import { createContext } from 'react';

import { AppFlags } from '../client/config';

const FlagsContext = createContext<AppFlags>({
  enableDonateToTeam: false,
  enableOtgAuction: false,
  enableOtgImmersiveGiving: false,
  enableOtgVideoChat: false,
  useCutterForSocialSharing: false,
  virtualFitnessEventsDebugFeatures: false,
  virtualFitnessEventsPreview: false,
  useLeaderboarFundraisersList: false,
  useLeaderboarFundraisersListForTeams: false,
  useOTGVideoGenerator: false,
  useOnePageForFundraisingPages: false,
  showTeamCreationCTAForOnePage: false,
});

export default FlagsContext;
FlagsContext.displayName = 'FlagsContext';

export const FlagsProvider = FlagsContext.Provider;
export const FlagsConsumer = FlagsContext.Consumer;
